import { TASK_PATH } from "@/modules/tasks/pages/task";
import { generatePath, Navigate } from "react-router-dom";

export function OpenTask() {
  const url = new URL(window.location.href);

  return (
    <Navigate
      to={generatePath(TASK_PATH, {
        id: url.searchParams.get("id"),
      })}
    />
  );
}
